var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.96,
    height: 33.368,
    viewBox: "0 0 36.96 33.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22970",
    "data-name": "Path 22970",
    d: "M32.4,9.569a5.088,5.088,0,0,1,8.318,4.82l0,.025A5.088,5.088,0,0,0,44.05,20.19h0a5.088,5.088,0,0,1,0,9.62h0a5.088,5.088,0,0,0-3.337,5.776l0,.025a5.088,5.088,0,0,1-8.318,4.82l-.078-.067a5.088,5.088,0,0,0-6.645,0l-.078.067a5.088,5.088,0,0,1-8.318-4.82l0-.025A5.088,5.088,0,0,0,13.95,29.81h0a5.088,5.088,0,0,1,0-9.62h0a5.088,5.088,0,0,0,3.337-5.776l0-.025A5.088,5.088,0,0,1,25.6,9.569l.078.067a5.088,5.088,0,0,0,6.645,0Z",
    transform: "translate(-10.52 -8.316)",
    fill: "#efb93f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star-yellow.2049c92d.svg";
export { ForwardRef as ReactComponent };